import {
  Snackbar,
  Alert,
  Backdrop,
  CircularProgress,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Grid,
  // Divider,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Box,
} from "@mui/material";
import { useState, useEffect } from "react";

// react-router-dom components
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";

// @mui material components
import Card from "@mui/material/Card";
// import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Authentication layout components
// import BasicLayout from "app/user/components/BasicLayoutSignUp";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import logo from "assets/images/logos/laddar_logo_long.png";

import axios from "axios.js";

// import { Formik } from "formik";
// import * as Yup from "yup";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

function SignUp() {
  const title = "Sign Up";
  usePageTitle(title);

  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated()) {
    navigate("/home");
  }

  const [searchParams] = useSearchParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [step, setStep] = useState(0);
  const [companyPayload, setCompanyPayload] = useState(null);
  const [contactPayload, setContactPayload] = useState(null);

  const [industries, setIndustries] = useState([]);
  const [countries, setCountries] = useState([]);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [plans, setPlans] = useState([]);

  const [companyName, setCompanyName] = useState(null);
  const [companyEmail, setCompanyEmail] = useState(null);
  const [companyPhone, setCampanyPhone] = useState(null);
  const [companyAddress, setCampanyAddress] = useState(null);
  const [companyIndustry, setCampanyIndustry] = useState(null);
  const [companyCountry, setCompanyCountry] = useState(null);
  const [companyBusinessType, setCompanyBusinessType] = useState(null);
  const [planDisabled, setPlanDisabled] = useState(null);
  const [companyPlan, setCompanyPlan] = useState(searchParams.get("plan"));
  const [sourceProduct, setSourceProduct] = useState(searchParams.get("product"));

  const [openOTPDialog, setOpenOTPDialog] = useState(false);
  const [otpRef, setOtpRef] = useState(null);
  const [oTP, setOTP] = useState(null);
  const [dataHash, setHash] = useState(null);
  const [openSuccessSignupDialog, setOpenSuccessSignupDialog] = useState(false);
  const [successMsg, setSuccessMsg] = useState(
    "Your account has been setup successfully. Please login."
  );

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/users/register/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setIndustries(result.data.data.industries);
            setCountries(result.data.data.countries);
            setBusinessTypes(result.data.data.business_types);
            setPlans(result.data.data.plans);

            if (sourceProduct !== null && sourceProduct === "voice"){
              setCompanyPlan("PAG");
              setPlanDisabled(true);
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function next() {
    if (companyPlan === null || companyPlan === "-") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Please select a plan.");
      setSeverity("error");
      return;
    }

    if (companyCountry === null || companyCountry === "-") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Company currency is required.");
      setSeverity("error");
      return;
    }

    if (companyIndustry === null || companyIndustry === "-") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Company industry is required.");
      setSeverity("error");
      return;
    }

    if (companyBusinessType === null || companyBusinessType === "-") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Company business type is required.");
      setSeverity("error");
      return;
    }

    if (companyName === null || companyName === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Company name is required.");
      setSeverity("error");
      return;
    }
    if (companyEmail === null || companyEmail === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Company email is required.");
      setSeverity("error");
      return;
    }
    if (companyPhone === null || companyPhone === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Company phone number is required.");
      setSeverity("error");
      return;
    }
    if (companyAddress === null || companyAddress === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Company address is required.");
      setSeverity("error");
      return;
    }

    const payload = {
      title: companyName,
      email_address: companyEmail,
      phone_number: companyPhone,
      address: companyAddress,
      industry: companyIndustry,
      country: companyCountry,
      business_type: companyBusinessType,
      plan: companyPlan,
    };
    setCompanyPayload(payload);
    setStep(1);
  }

  const [lastName, setLastName] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [password, setPassword] = useState(null);
  const [cPassword, setCPassword] = useState(null);
  const [acceptTC, setAcceptTC] = useState(false);

  async function validateUserInfo() {
    if (lastName === null || lastName === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Last name is required.");
      setSeverity("error");
      return;
    }

    if (firstName === null || firstName === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("First name is required.");
      setSeverity("error");
      return;
    }

    if (emailAddress === null || emailAddress === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Email is required.");
      setSeverity("error");
      return;
    }
    if (phoneNumber === null || phoneNumber === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Phone number is required.");
      setSeverity("error");
      return;
    }
    if (password === null || password === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Password is required.");
      setSeverity("error");
      return;
    }

    if (cPassword !== password) {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Repeat password mismatch.");
      setSeverity("error");
      return;
    }

    if (acceptTC !== true) {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Please accept the terms and conditions");
      setSeverity("error");
      return;
    }

    const payload = {
      last_name: lastName,
      first_name: firstName,
      email_address: emailAddress,
      phone_number: phoneNumber,
      password: `${password}`,
    };

    setContactPayload(payload);
    console.log(contactPayload);

    const json = {
      company: companyPayload,
      contact: payload,
    };

    setShowLoading(true);
    await axios
      .post(`portal/users/register/validate.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          //   setSeverity("success");
          //   setErrMsg(result.data.data.message);
          //   setOpen(true);

          setOtpRef(result.data.data.reference);
          setHash(result.data.data.data);
          setOpenOTPDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createAccount() {
    if (oTP === null || oTP === "") {
      setOpen(true);
      setShowLoading(false);
      setErrMsg("Please enter your verification");
      setSeverity("error");
      return;
    }

    const json = {
      otp: {
        reference: otpRef,
        otp: oTP,
      },
      data: dataHash,
    };

    setOpenOTPDialog(false);
    setShowLoading(true);
    await axios
      .post(`portal/users/register/create.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSuccessMsg(result.data.data.message);
          setOpenSuccessSignupDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <PageLayout image={bgImage}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openSuccessSignupDialog} maxWidth="xs" fullWidth>
        <DialogContent>
          <MDBox mb={3}>
            <MDBox mt={1} align="center">
              <MDTypography variant="h6" fontWeight="regular">
                Registration Complete
              </MDTypography>
              <MDBox mt={3} mb={3}>
                <MDBox mt={1} align="center">
                  <Box sx={{ position: "relative", display: "inline-flex" }}>
                    <CircularProgress
                      variant="determinate"
                      size={80}
                      thickness={3}
                      value={100}
                      color="success"
                    />
                    <Box
                      sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon fontSize="large" color="success">
                        check
                      </Icon>
                    </Box>
                  </Box>
                </MDBox>
              </MDBox>
              <MDTypography variant="h6" fontWeight="light">
                {successMsg}
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="info" variant="contained" onClick={() => navigate("/sign-in")}>
            <Icon fontSize="lg">login_in</Icon>&nbsp; &nbsp;Login
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openOTPDialog}>
        <DialogTitle>
          <MDBox>OTP Verification</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <MDTypography variant="h6" fontWeight="light">
              Enter the verification code sent to your contact email.
            </MDTypography>
            <MDBox mt={4}>
              <MDInput
                name="otp"
                id="otp"
                type="text"
                label="OTP"
                variant="outlined"
                fullWidth
                onChange={(e) => setOTP(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenOTPDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton color="info" variant="outlined" onClick={() => createAccount()}>
            Proceed
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox
        sx={{
          margin: "30px auto",
          maxWidth: 800,
        }}
      >
        {/* <MDBox mb={3} mt={5}>
          <Card>
            <MDBox
              bgColor={AppConfig.sidenav_active_menu_color}
              borderRadius="lg"
              coloredShadow="info"
              mx={5}
              mt={-3}
              p={2}
              mb={3}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                Laddar Africa
              </MDTypography>
              <MDTypography display="block" variant="button" color="white" my={1}>
                Welcome! Create your account to get started!
              </MDTypography>
            </MDBox>
          </Card>
        </MDBox> */}
        <MDBox align="center">
          <a href="https://laddar.africa">
            <img src={logo} alt="" width={150} />
          </a>
        </MDBox>
        <MDBox align="center" mt={0}>
          <MDTypography variant="subtitle2" fontWeight="regular" fontSize={14}>
            {AppConfig.tag_line}
          </MDTypography>
        </MDBox>
        <MDBox mb={5} mt={5}>
          <Card>
            <MDBox pt={4} pb={3} px={3}>
              {step === 0 ? (
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    Company Information
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light">
                    Enter your company details below
                  </MDTypography>
                  <MDBox mt={3}>
                    {/* <MDBox mb={3}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>Currency</InputLabel>
                        <Select
                          label="Currency"
                          value={companyCurrency}
                          name="companyCurrency"
                          id="companyCurrency"
                          onChange={(e) => {
                            setCompanyCurrency(e.target.value);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                        >
                          {
                            // --> Notice below changes
                            currencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                              currencies.map((record) => (
                                <MenuItem value={record.reference}>{record.title}</MenuItem>
                              ))
                          }
                        </Select>
                      </FormControl>
                    </MDBox> */}

                    <MDBox mb={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel shrink={Boolean(companyPlan)}>Select Plan</InputLabel>
                            <Select
                              notched={Boolean(companyPlan)}
                              label="Select Plan"
                              value={companyPlan}
                              name="companyPlan"
                              id="companyPlan"
                              // readOnly={searchParams.get("plan") ? true : false}
                              onChange={(e) => {
                                setCompanyPlan(e.target.value);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                              disabled={planDisabled}
                            >
                              {
                                // --> Notice below changes
                                plans.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  plans.map((record) => (
                                    <MenuItem value={record.reference}>{record.title}</MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Country</InputLabel>
                            <Select
                              label="Country"
                              value={companyCountry}
                              name="companyCountry"
                              id="companyCountry"
                              onChange={(e) => {
                                setCompanyCountry(e.target.value);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              {
                                // --> Notice below changes
                                countries.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  countries.map((record) => (
                                    <MenuItem value={record.reference}>{record.title}</MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mb={5}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Industry</InputLabel>
                            <Select
                              label="Industry"
                              value={companyIndustry}
                              name="companyIndustry"
                              id="companyIndustry"
                              onChange={(e) => {
                                setCampanyIndustry(e.target.value);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              {
                                // --> Notice below changes
                                industries.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  industries.map((record) => (
                                    <MenuItem value={record.reference}>{record.title}</MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Business Type</InputLabel>
                            <Select
                              label="Business Type"
                              value={companyBusinessType}
                              name="companyBusinessType"
                              id="companyBusinessType"
                              onChange={(e) => {
                                setCompanyBusinessType(e.target.value);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              {
                                // --> Notice below changes
                                businessTypes.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  businessTypes.map((record) => (
                                    <MenuItem value={record.reference}>{record.title}</MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mt={3} mb={3}>
                      <MDInput
                        value={companyName}
                        name="companyName"
                        id="companyName"
                        type="text"
                        label="Company Name"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                    </MDBox>

                    <MDBox mb={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDInput
                            value={companyEmail}
                            name="companyEmail"
                            id="companyEmail"
                            type="text"
                            label="Company Email"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setCompanyEmail(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDInput
                            value={companyPhone}
                            name="companyPhone"
                            id="companyPhone"
                            type="text"
                            label="Company Phone Number"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setCampanyPhone(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mb={3}>
                      <MDInput
                        multiline
                        rows={3}
                        value={companyAddress}
                        name="companyAddress"
                        id="companyAddress"
                        type="text"
                        label="Company Address"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => setCampanyAddress(e.target.value)}
                      />
                    </MDBox>
                    <MDBox align="right">
                      <MDBox mt={4} mb={1}>
                        <MDButton
                          variant="gradient"
                          color={AppConfig.sidenav_active_menu_color}
                          onClick={() => next()}
                        >
                          Next
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              ) : (
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    Contact Information
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light">
                    Enter your personal details
                  </MDTypography>
                  <MDBox mt={3}>
                    <MDBox mb={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDInput
                            value={lastName}
                            name="lastName"
                            id="lastName"
                            type="text"
                            label="Last Name"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDInput
                            value={firstName}
                            name="firstName"
                            id="firstName"
                            type="text"
                            label="First Name"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mb={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDInput
                            value={emailAddress}
                            name="emailAddress"
                            id="emailAddress"
                            type="text"
                            label="Email Address"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setEmailAddress(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDInput
                            value={phoneNumber}
                            name="phoneNumber"
                            id="phoneNumber"
                            type="text"
                            label="Phone Number"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setPhoneNumber(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                    <MDBox mb={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDInput
                            value={password}
                            name="password"
                            id="password"
                            type="password"
                            label="Password"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDInput
                            value={cPassword}
                            name="cPassword"
                            id="cPassword"
                            type="password"
                            label="Repeat Password"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setCPassword(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" alignItems="center" ml={-1}>
                    <Checkbox
                      checked={acceptTC}
                      onChange={(e) => {
                        setAcceptTC(e.target.checked);
                      }}
                    />
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                    >
                      &nbsp;&nbsp;I accept the&nbsp;
                    </MDTypography>
                    <MDTypography
                      component="a"
                      href="https://laddar.africa/terms-conditions/"
                      variant="button"
                      fontWeight="bold"
                      color="info"
                      textGradient
                      target="_blank"
                    >
                      Terms and Conditions
                    </MDTypography>
                  </MDBox>
                  <MDBox align="right">
                    <MDBox mt={4} mb={1}>
                      <MDButton
                        variant="outlined"
                        color={AppConfig.sidenav_active_menu_color}
                        onClick={() => setStep(0)}
                      >
                        Back
                      </MDButton>
                      &nbsp;&nbsp;
                      <MDButton
                        variant="gradient"
                        color={AppConfig.sidenav_active_menu_color}
                        onClick={() => validateUserInfo()}
                      >
                        Next
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              )}
            </MDBox>
            <MDBox>
              <MDBox mt={1} mb={3} textAlign="center">
                <MDTypography variant="button" color="text">
                  Already have an account?{" "}
                  <MDTypography
                    component={Link}
                    to="/sign-in"
                    variant="button"
                    color={AppConfig.sidenav_active_menu_color}
                    fontWeight="medium"
                    textGradient
                  >
                    Sign In
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>
    </PageLayout>
  );
}

export default SignUp;
